import React, { useEffect, useState } from "react"
import Flink from '~/components/shared/flink'
import { useTheme } from '~/contexts/ThemeContext'
import { notBlank, imgSize, jnstyls } from '~/utils/helpers'

import VideoNoControl from '~/components/video/no-controls'
import VideoControls from '~/components/video/controls'

import * as styles from "~/styles/home/home-img.module.scss"


const checkRatio = (block) => {
  const types = ['hero','hero_wide','full_bleed']
  const type = block.type
  if (!types.includes(type)) return ''

  const desk_ratio = block?.desk_size?.ratio || false
  const mobi_ratio = block?.mobi_size?.ratio || false
  let ratio_style = ''
  const block_attr = `[mid="${block.id}"] [himg]`
  if (desk_ratio) {
    ratio_style += `
      @media only screen and (min-width: 820px) {
        ${block_attr} {
          aspect-ratio: ${desk_ratio} auto;
        }
      }
    `
  }
  if (mobi_ratio) {
    ratio_style += `
      @media only screen and (max-width: 819px) {
        ${block_attr} {
          aspect-ratio: ${mobi_ratio} auto;
        }
      }
    `
  }
  return ratio_style
}

const HomeImg = ({ item, show_mobile, pstyles={}, block}) => {
  const { setGender } = useTheme()
  const { url, image, mobile_image } = item
  const type = block.type

  const is_linked = notBlank(url) && block.id !== 2059
  const [didLoad, setDidLoad] = useState(false)
  const [media, setMedia] = useState(null)

  const desk_vid = item.hasOwnProperty('vid_handle') ? item.vid_handle : false
  let mobi_vid = item.hasOwnProperty('mobile_vid_handle') ? item.mobile_vid_handle : false
  if (desk_vid && !mobi_vid) mobi_vid = desk_vid
  let mobi_img = mobile_image ? mobile_image : image

  const twoimg_vid = type === 'two_off' && notBlank(item.vid_handle)

  const handleGenderClick = (url) => {
    setGender(url.replace('/?g=',''))
    setTimeout(()=>{
      window.scrollTo(...[0, 0])
      const element = document.querySelector('#header')
      if (!element) return
      element.style.transform = `translate(0, 0%)`;
    }, 20)
  }

  const hero_types = ['hero','hero_wide','full_bleed']
  let use_link = !!is_linked
  if (desk_vid && block.vid_controls) use_link = false
  if (hero_types.includes(type) && notBlank(url)) use_link = false

  const ratio_style = checkRatio(block)

  useEffect(() => {
    setMedia({type, image, mobi_img, desk_vid, mobi_vid})
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  
  return (
    <>
      {notBlank(ratio_style) && (<style>{ratio_style}</style>)}

      <div className={jnstyls([styles.himage, pstyles.himage])} himg={''}>
        {(media && use_link) && (
          <>
            {url.includes('/?g=') ? (
              <button type="button" onClick={(e)=>{ handleGenderClick(url) }}>
                <Media mediaObj={media} block={block} />
              </button>
            ) : (
              <Flink href={url} >
                <Media mediaObj={media} block={block} />
              </Flink>
            )}
          </>
        )}
        {(media && !use_link) && (
          <Media mediaObj={media} block={block} />
        )}
        {(media && type === 'journal') && (
          <div className={styles.journ_tag}>
            {url && url?.includes('journal') ? 'The Journal' 
              : url && url?.includes('knitting') ? 'Our Factory' 
              : (url?.includes('feature/') || url?.includes('/collections/')) ? 'Featured' 
              : 'Our Stores'}
          </div>
        )}
      </div>
    </>
  )
}


const Media = ({ mediaObj, block }) => {
  const { pageLoad, isMobile } = useTheme()
  const {type, image, mobi_img, desk_vid, mobi_vid} = mediaObj

  const [video, setVideo] = useState(null)

  const has_image = !!(image || mobi_img)
  const has_video = !!(desk_vid || mobi_vid)

  const hero_type = (['hero_wide','hero','full_bleed']).includes(type)

  const image_size = () => {
    if (isMobile) return imgSize(mobi_img, pageLoad ? 900 : 10)
    if (type === 'hero_wide' || type === 'full_bleed') return imgSize(image, pageLoad ? 1800 : 10)
    if (type === 'hero') return imgSize(image, pageLoad ? 1400 : 10) 
    return imgSize(image, pageLoad ? 900 : 10)
  }

  useEffect(() => {
    if (!has_video) return
    const handle = !isMobile ? desk_vid : mobi_vid
    setVideo(handle)
  }, [isMobile, has_video, desk_vid, mobi_vid])

  return (
    <>
      {(has_image && !has_video) && (
        <img 
          className={styles.himg} 
          src={image_size()} 
          alt=''
          width={hero_type ? 1100 : 600} height={hero_type ? 800 : 740} 
        />
      )}
      {(has_video && video && !!block.vid_controls) ? (
        <VideoControls 
          handle={video}
          par_styles={`${styles.video}`}
          loopAuto={true}
        />
      ) : (has_video && video) ? (
        <VideoNoControl 
          handle={video}
          par_styles={styles.video}
        />
      ) : (<></>)}
    </>
  )
}



export default HomeImg


// <div className={`${styles.himage} ${!isMobile ? styles.nd_headNomob : ''}`}>



